export enum ApplicationStatus {
  COMPANY_APPROVED = "CompanyApproved",
  COMPANY_REJECTED = "CompanyRejected",
  COMPANY_CANCELLED = "CompanyCancelled",
  STUDENT_CANCELLED = "StudentCancelled",
  SCHOOL_CANCELLED = "SchoolCancelled",
  WAITING_FOR_SCHOOL_APPROVAL = "WaitingForSchoolApproval",
  WAITING_FOR_COMPANY_APPROVAL = "WaitingForCompanyApproval",
  WAITING_FOR_ADMIN_APPROVAL = "WaitingForAdminApproval",
  ADMIN_REJECTED = "AdminRejected",
}
